const PublicPageBackground = () => {
    return (
        <div className="fixed inset-0 pointer-events-none -z-10">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/[0.04] via-background to-secondary/[0.04] dark:from-primary/[0.08] dark:via-background dark:to-secondary/[0.08]" />
            <div
                className="absolute inset-0 opacity-40 dark:opacity-30"
                style={{
                    backgroundImage:
                        "radial-gradient(circle, hsl(var(--border) / 0.6) 1px, transparent 1px)",
                    backgroundSize: "24px 24px",
                }}
            />
            <div className="absolute -top-24 -right-24 w-[28rem] h-[28rem] bg-primary/10 dark:bg-primary/15 rounded-full blur-3xl" />
            <div className="absolute -bottom-32 -left-24 w-[26rem] h-[26rem] bg-secondary/10 dark:bg-secondary/15 rounded-full blur-3xl" />
            <div className="absolute top-1/3 -left-32 w-72 h-72 bg-green-500/8 dark:bg-green-500/12 rounded-full blur-3xl" />
            <div className="absolute top-2/3 -right-20 w-72 h-72 bg-amber-500/8 dark:bg-amber-500/12 rounded-full blur-3xl" />
        </div>
    );
};

export default PublicPageBackground;
